// extracted by mini-css-extract-plugin
export var tooltip = "TooltipStyles-module--tooltip--0cbd0";
export var tooltipArrow = "TooltipStyles-module--tooltip-arrow--8ed74";
export var tooltipIcon = "TooltipStyles-module--tooltip-icon--a0af7";